export const headerCenterNav = [
    {
        path: "/activity/financial-activity",
        id: 0,

    },
    {
        path: "http://www.science-tstu.uz/",
        id: 1,
    },
    {
        path: "https://t.me/TDTU_ELEKTRON_KUTUBXONA",
        id: 2,

    },
    {
        path: "/preparation",
        id: 3,

    },
    {
        path: "https://sdg.tdtu.uz",
        id: 4,
        img: "https://test.tdtu.uz/storage/bussins/January2026/KPPCINUw93JLO7TGQHDc.webp",
    },
];

export const headerBottomNav = [
    {
        id: 1,
        path: "university",
    },
    {
        id: 2,
        path: "structure",
    },
    {
        id: 3,
        path: "activity",
    },
    {
        id: 4,
        path: "students",
    },

    {
        id: 6,
        path: "abiturient",
    },
    {
        id: 7,
        path: "corruption",
    },
    {
        id: 8,
        path: "new",
    },
];

export const headerBottomNavItemMenu = [
    {
        id: 1,
        data: [
            {
                id: 1,
                path: "/university/rectors-congratulation",
            },
            {
                id: 2,
                path: "/university/requisites",
            },
            {
                id: 3,
                path: "/university/regulations-university",
            },
            {
                id: 4,
                path: "/university/rector-virtual-reception",
            },
            {
                id: 5,
                path: "/university/regulatory-documents",
            },
            {
                id: 6,
                path: "/university/history-university",
            },
            {
                id: 7,
                path: "https://test.tdtu.uz/storage/pages/December2025/NZcTpHIvq6QKTzuzaMo1.pdf",
                url: "a"
            },
        ],
    },
    {
        id: 2,
        data: [
            {
                path: "/structure/rectorate",
                id: 1,
            },
            {
                path: "/",
                id: 2,
                children: [
                    {
                        path: "/structure/centers/1",
                        id: 1,
                    },
                    {
                        path: "/structure/centers/2",
                        id: 2,
                    },
                    {
                        path: "/structure/centers/3",
                        id: 3,
                    },
                    {
                        path: "/structure/centers/4",
                        id: 4,
                    },
                    {
                        path: "/structure/centers/5",
                        id: 5,
                    },
                    {
                        path: "/structure/centers/6",
                        id: 6,
                    },
                ],
                subMenuId: 1,
            },
            {
                path: "/",
                id: 3,
                children: [
                    {
                        path: "/structure/sections/21",
                        id: 21,
                    },
                    {
                        path: "/structure/sections/1",
                        id: 1,
                    },
                    {
                        path: "/structure/sections/2",
                        id: 2,
                    },
                    {
                        path: "/structure/sections/3",
                        id: 3,
                    },
                    {
                        path: "/structure/sections/4",
                        id: 4,
                    },
                    {
                        path: "/structure/sections/5",
                        id: 5,
                    },
                    {
                        path: "/structure/sections/6",
                        id: 6,
                    },
                    {
                        path: "/structure/sections/7",
                        id: 7,
                    },
                    {
                        path: "/structure/sections/8",
                        id: 8,
                    },
                    {
                        path: "/structure/sections/9",
                        id: 9,
                    },
                    {
                        path: "/structure/sections/10",
                        id: 10,
                    },
                    {
                        path: "/structure/sections/11",
                        id: 11,
                    },
                    {
                        path: "/structure/sections/12",
                        id: 12,
                    },

                    {
                        path: "/structure/sections/14",
                        id: 14,
                    },
                    {
                        path: "/structure/sections/15",
                        id: 15,
                    },
                    {
                        path: "/structure/sections/16",
                        id: 16,
                    },
                    {
                        path: "/structure/sections/17",
                        id: 17,
                    },
                    {
                        path: "/structure/sections/18",
                        id: 18,
                    },
                    {
                        path: "/structure/sections/19",
                        id: 19,
                    },
                    {
                        path: "/structure/sections/20",
                        id: 20,
                    },
                    {
                        path: "/structure/sections/22",
                        id: 22,
                    },
                ],
                subMenuId: 2,
            },
            {
                path: "/structure/faculties",
                id: 4,
            },
            {
                path: "/structure/kafedra",
                id: 5,
            },
            {
                path: "/",
                id: 6,
                children: [
                    {
                        path: "/structure/branches/1",
                        id: 1,
                    },
                    {
                        path: "/structure/branches/2",
                        id: 2,
                    },
                ],
                subMenuId: 3,
            },
            {
                id: 7,
                children: [
                    {
                        path: "/u1",
                        id: 1,
                    },
                    {
                        path: "/u2",
                        id: 2,
                    },
                    {
                        path: "/u3",
                        id: 3,
                    },
                    {
                        path: "/u4",
                        id: 4,
                    },

                ],
                subMenuId: 5,
            },
        ],
    },
    {
        id: 3,
        data: [
            {
                path: "/",
                id: 1,
                children: [
                    {
                        path: "/activity/Composition_of_the_Academic_Council",
                        id: 1,
                    },
                    {
                        path: "/activity/innovation",
                        id: 2,
                    },
                    {
                        path: "/activity/doctoral-studies",
                        id: 3,
                    },
                ],
                subMenuId: 4,
            },
            {
                path: "/activity/chemists",
                id: 7,
            },
            {
                path: "/scientific/conferences",
                id: 9,
            },
            {
                path: "/scientific/magazines",
                id: 6,
            },
            {
                path: "/activity/youth-work",
                id: 3,
            },
            {
                path: "/activity/cultural-education",
                id: 4,
            },
            {
                path: "/activity/international-cooperation",
                id: 5,
            },
            {
                path: "/scientific/laboratories",
                id: 8,
            },
            {
                path: "scientific/master",
                id: 10
            }

        ],
    },
    {
        id: 4,
        data: [

            {
                path: "/students/ecofaol-talabalar",
                id: 48,
            },
            {
                path: "/students/edu",
                id: 39,
            },
            {
                path: "/students/schedule",
                id: 40,
            },
            {
                path: "/",
                id: 41,
                children: [
                    {
                        path: "/students/undergraduate",
                        id: 1,
                    },
                    {
                        path: "/students/undergraduate6",
                        id: 6,
                    },
                    {
                        path: "/students/undergraduate2",
                        id: 2,
                    },
                    {
                        path: "/students/undergraduate3",
                        id: 3,
                    },
                    {
                        path: "/students/60610100",
                        id: 4,
                    },
                    {
                        path: "/students/60710800",
                        id: 5,
                    },
                ],
                subMenuId: 6,
            },
            {
                path: "/",
                id: 42,
                children: [
                    {
                        path: "/students/judiciary",
                        id: 1,
                    },
                    {
                        path: "/students/judiciary6",
                        id: 6,
                    },
                    {
                        path: "/students/judiciary2",
                        id: 2,
                    },
                    {
                        path: "/students/judiciary3",
                        id: 3,
                    },
                    {
                        path: "/students/70710802",
                        id: 4,
                    },
                    {
                        path: "/students/70710903 ",
                        id: 5,
                    },
                ],
                subMenuId: 9,
            },
            {
                path: "/students/evening",
                id: 3,
            },
            {
                path: "/students/external",
                id: 4,
            },
            {
                path: "/students/talented",
                id: 5,
            },
            {
                path: "/",
                id: 46,
                children: [
                    {
                        path: "/students/exams",
                        id: 1,
                    },
                    {
                        path: "/students/exams1",
                        id: 2,
                    },
                    {
                        path: "/students/exams2",
                        id: 3,
                    },
                    {
                        path: "/students/exams3",
                        id: 4,
                    },
                ],
                subMenuId: 7,
            },
            {
                path: "/",
                id: 47,
                children: [
                    {
                        path: "/students/surveys",
                        id: 1,
                    },
                    {
                        path: "/students/surveys1",
                        id: 2,
                    },
                    {
                        path: "/students/surveys2",
                        id: 3,
                    },
                ],
                subMenuId: 8,
            },
        ],
    },

    {
        id: 6,
        data: [
            {
                path: "/abiturient/undergraduate",
                id: 1,
            },
            {
                path: "/abiturient/judiciary",
                id: 2,
            },
            {
                path: "/abiturient/external-evening",
                id: 3,
            },
            {
                path: "/abiturient/mixed-education",
                id: 4,
            },
            {
                path: "/abiturient/foreign-citizens",
                id: 5,
            },
            {
                path: "/abiturient/study-in-Uzbekistan",
                id: 6,
            },
        ],
    },
    {
        id: 7,
        column: true,
        data: [
            {
                path: "/corruption/1",
                id: 1,
            },
            {
                path: "/corruption/2",
                id: 2,
            },
            {
                path: "/corruption/3",
                id: 3,
            },
            {
                path: "/corruption/4",
                id: 4,
            },
            {
                path: "/corruption/5",
                id: 5,
            },
            {
                path: "/corruption/6",
                id: 6,
            },
            {
                path: "/corruption/7",
                id: 7,
            },
            {
                path: "/corruption/8",
                id: 8,
            },
            {
                path: "/corruption/9",
                id: 9,
            },
        ],
    },
    {
        id: 8,

        data: [
            {
                path: "/new/news",
                id: 1,
            },
            {
                path: "/new/events",
                id: 2,
            },
            {
                path: "/new/announcements",
                id: 3,
            },
            {
                path: "/new/sport",
                id: 4,
            },
        ],
    },
];
